import consts from '../consts'

let locale

const obtainLocale = () => {
  if (localStorage.getItem('language')) {
    locale = localStorage.getItem('language')
  } else {
    let lang = navigator.language.split('-')[0]
    if (lang && consts.ACCEPTED_LOCALES.indexOf(lang) >= 0) {
      locale = lang
    } else {
      locale = consts.DEFAULT_LOCALE
    }
    localStorage.setItem('language', locale)
  }
  return locale
}

export default obtainLocale



// WEBPACK FOOTER //
// ./src/translator/localeHelper.js